import { defaultColor } from "./default.js";
import { errorColor } from "./error.js";
import { infoColor } from "./info.js";
import { newColor } from "./new.js";
import { successColor } from "./success.js";
import { warningColor } from "./warning.js";
const status_status = (mode)=>({
        default: defaultColor(mode),
        new: newColor(mode),
        info: infoColor(mode),
        success: successColor(mode),
        warning: warningColor(mode),
        error: errorColor(mode)
    });
export { status_status as status };

//# sourceMappingURL=index.js.map